export default {
  data() {
    return { matchRows: [], matchLoading: false, matchError: '', matchVersion: 0, previewPage: 1 }
  },
  computed: {
    visiblePackingRows() { return this.rows.slice((this.previewPage - 1) * 10, this.previewPage * 10) },
    previewPages() { return Math.max(1, Math.ceil(this.rows.length / 10)) },
    choicesReady() {
      return !this.matchLoading && !this.matchError && (this.selectedHeaders.s == null ||
        (this.matchRows.length === this.rows.length && this.matchRows.every(r => r.mode === 'new' || r.product_id)))
    }
  },
  watch: {
    selectedHeaders: { deep: true, handler() { this.refreshPackingMatches() } },
    uploadedFileId() { this.refreshPackingMatches() }
  },
  methods: {
    packingErrorMessage(error, fallback) {
      const data = error && error.response && error.response.data
      if (!data) return fallback
      if (data.detail) return String(data.detail)
      const errors = data.rows || data.row_choices
      if (errors && typeof errors === 'object') return Object.entries(errors)
        .map(([index, message]) => `ردیف ${Number(index) + 1}: ${Array.isArray(message) ? message.join('، ') : message}`).join('؛ ')
      const messages = value => typeof value === 'string' ? [value] : Array.isArray(value)
        ? value.flatMap(messages) : value && typeof value === 'object'
          ? Object.entries(value).filter(([key]) => key !== 'field').flatMap(([, value]) => messages(value)) : []
      return messages(data).join('؛ ') || fallback
    },
    refreshPackingMatches() {
      const version = ++this.matchVersion
      this.matchRows = []
      this.matchError = ''
      this.matchLoading = false
      this.previewPage = 1
      if (!this.uploadedFileId || this.selectedHeaders.s == null) return
      this.matchLoading = true
      this.request({
        url: this.endpoint('file_handler/packingProductMatches'), method: 'post',
        data: { file_id: this.uploadedFileId, selected_headers: this.selectedHeaders },
        success: data => {
          if (version !== this.matchVersion) return
          this.matchRows = data.rows.map(r => ({ ...r, mode: r.products.length ? 'existing' : 'new',
            product_id: r.products.length === 1 ? r.products[0].id : null }))
          this.matchLoading = false
        },
        error: error => {
          if (version !== this.matchVersion) return
          this.matchLoading = false
          this.matchError = this.packingErrorMessage(error, 'تطبیق GTIN انجام نشد؛ ستون و مقادیر را بررسی کنید و دوباره تلاش کنید.')
        }
      })
    },
    packingChoiceBody() {
      if (this.selectedHeaders.s == null) return {}
      return { row_choices: Object.fromEntries(this.matchRows.map(r => [r.row_id,
        { mode: r.mode, product_id: r.mode === 'new' ? null : r.product_id }])) }
    },
    toggleNewPackingProduct(row) {
      if (row.mode === 'new') row.product_id = null
      else row.product_id = row.products.length === 1 ? row.products[0].id : null
    }
  }
}
